import * as DialogPrimitive from '@radix-ui/react-dialog';
import styled, { keyframes } from 'styled-components';
import { IconButton } from '@mui/material';
import { Box } from 'components/Box';
import { Text } from 'components/Text';
import { HeaderSignupButton } from 'components/Header/HeaderStyled';

export const overlayShow = keyframes`
    0%  { opacity: 0 };
    100%  { opacity: 1 };
`;

export const contentShow = keyframes`
    0% {
        opacity: 0;
        transform: translate(-50%, -48%) scale(.96);
    };
    100% { 
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    };
`;

export const StyledOverlay = styled(DialogPrimitive.Overlay)`
    background: rgba(0 0 0 / 0.7);
    position: fixed;
    display: grid;
    place-items: center; 
    overflow-y: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;

    @media (prefers-reduced-motion: no-preference): {
        animation: ${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1)
    },
`;

export const StyledContent = styled(DialogPrimitive.Content)`
    background-color: ${(props) => props.theme.colors.text};
    box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
    width: 430px;
    position: relative;
    ${({ theme }) => theme.mediaQueries.xs} {
        max-width: 350px;
        padding: 10px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        max-width: 600px;
        padding: 40px;
    }

    @media (prefers-reduced-motion: no-preference): {
        animation: ${contentShow} 150ms cubic - bezier(0.16, 1, 0.3, 1)
    };
    &:focus: { outline: none };
`;

export const LoginButtonHeaderStyle = styled.div`
    all: unset;
    color: ${(props) => props.theme.colors.text};
	margin: 0px 14px;
	text-decoration: none;
	cursor:pointer;
	font-weight: 500;
	font-size: 18px;
	line-height: 35px;
	display: flex;

	:hover{
		color: ${(props) => props.theme.colors.primary};
	}
`
export const SafeGuardStyle = styled(Box)`
    position: absolute;
    top: -40px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    left: 0;
`

export const IconButtonStyle = styled(IconButton)`
    padding: 5px !important;
    border-radius: 0px !important;
    color: ${(props) => props.theme.colors.primary} !important;
    background-color: ${(props) => props.theme.colors.imgBackgroundColor} !important;
`
export const ModelTopMargin = styled(Box)`
    margin-top: 30px;
`

function Content({ children, ...props }) {
    return (
        <DialogPrimitive.Portal>
            <StyledOverlay >
                <StyledContent {...props}>{children}</StyledContent>
            </StyledOverlay>
        </DialogPrimitive.Portal>
    );
}

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogContent = Content;
export const DialogClose = DialogPrimitive.Close;

export const MenuModel = styled(DialogTrigger)`
    all: unset;
    color: #001FFF;
	margin: 0px 14px;
	text-decoration: none;
	cursor:pointer;
	font-weight: 500;
	font-size: 18px;
	line-height: 35px;
	display: flex;
    background-color: transparent;

	:hover{
		color: ${(props) => props.theme.colors.primary};
	}
`
export const MenuModelText = styled(Text)`
    font-size: 16px;
    margin-right: 3px;
    font-weight: 400;
    color: ${(props) => props.theme.colors.textSubtle};
`

export const FormsBtn = styled(HeaderSignupButton)``

export const FormsBtnStyling = styled(FormsBtn)`
    all: unset;
    margin: 10px 0px;
    color: #001FFF;

    :hover{
		color: ${(props) => props.theme.colors.primary};
	}
`

export const TriggerStyling = styled(HeaderSignupButton)`
    all: unset;
    margin: 10px 0px;
    color: #001FFF;

    :hover{
		color: ${(props) => props.theme.colors.primary};
	}
`
export const FormErrorColor = styled(Box)`
    color: #FF0000;
`
export const FormForgotText = styled(Text)`
    font-size: 20px;
    color: ${(props) => props.theme.colors.textSubtle};
    font-weight: bold;
`